import type { CommonColumns } from './common_columns';
import { commonColumns } from './common_columns';
import { organizations } from './organizations';

type Contracts = CommonColumns & {
  resourceName: string;
  organizationId: string;
  salesSysadminId: string;
  approvalStatus: string;
  approvalRequestAt: string;
  approvalResponseAt: string;
  trial: string;
  price: string;
  billedOn: string;
  serviceSpecialNotes: string;
  userSpecialNotes: string;
  sysadminMemo: string;
  correctionRequest: string;
  fileName: string;
  file: string;
  fileSentAt: string;
  fileVisible: string;
  confirmationMail: string;
};

export const contracts: Readonly<Contracts> = {
  ...commonColumns,
  ...{
    resourceName: '申込',
    organizationId: `${organizations.resourceName}${organizations.id}`,
    salesSysadminId: '販売担当者',
    approvalStatus: 'ステータス',
    approvalRequestAt: '承認リクエスト送信日時',
    approvalResponseAt: '承認リクエスト返信日時',
    trial: '無料トライアル',
    price: '金額（税込み）',
    billedOn: '請求日',
    serviceSpecialNotes: '備考',
    userSpecialNotes: 'ユーザー規約特記事項',
    sysadminMemo: '【SIGNATE社内用】請求メモ',
    correctionRequest: '修正依頼',
    fileName: '請求書名',
    file: '請求書',
    fileSentAt: '請求書ファイル送信日時',
    fileVisible: '組織管理画面に請求書表示/非表示',
    confirmationMail: '申込み確認メール',
  },
};

export const contractsApprovalStatus: ReadonlyArray<
  'pending' | 'approved' | 'rejected'
> = ['pending', 'approved', 'rejected'];

// FIXME: refine
export const contractsApprovalStatusName = (
  status: 'pending' | 'approved' | 'rejected' | undefined
): string => {
  switch (status) {
    case 'pending':
      return '未承認';
    case 'approved':
      return '承認済';
    case 'rejected':
      return '修正待ち';
    default:
      return '';
  }
};

// FIXME: refine
export const contractsApprovalStatusClass = (
  status: 'pending' | 'approved' | 'rejected' | undefined
) => {
  switch (status) {
    case 'pending':
      return 'text-warning';
    case 'approved':
      return 'text-success';
    case 'rejected':
      return 'text-danger';
    default:
      return '';
  }
};

export const contractsFileVisibleName = (
  fileVisible: 'true' | 'false' | boolean
) => {
  const parsedFileVisible: boolean =
    typeof fileVisible === 'boolean' ? fileVisible : JSON.parse(fileVisible);

  return parsedFileVisible ? '表示' : '非表示';
};
